module.exports = __webpack_public_path__ + "static/media/na.e60de663.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/na.svg
// module id = 992
// module chunks = 0